<template>
  <el-dialog class="k-promo-edit-form" :title="promo && promo._id ? `Редактирвание акции ${promo.name}` : 'Создание новой акции'" :visible.sync="dialogFormVisible">
    <div class="k-promo-edit-form__container">
      <p class="k-promo-edit-form__title">Вы можете отредактирвать информацию об акции. И сохранить ее в базе данных:</p>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Название акции:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="name"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Описание акции:</el-col>
        <el-col :span="16"><el-input placeholder="Описание акции" v-model="description" type="textarea" :rows="4"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Почта организатора:</el-col>
        <el-col :span="16"><el-input placeholder="Email" v-model="email"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Фонд</el-col>
        <el-col :span="16">
          <el-select v-model="foundationId" :default-first-option="true" placeholder="Выбрать фонд">
            <el-option
              v-for="item in foundations"
              :key="item._id"
              :label="item.title"
              :value="item._id"
            />
          </el-select>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Сумма:</el-col>
        <el-col :span="16">
          <el-input-number v-model="amount" :min="1" :step="100"></el-input-number>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Дата старта:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="Pick a day">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Дата окончания:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="Pick a day">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-col :span="8" class="k-promo-edit-form__label">Место:</el-col>
        <el-col :span="16">
          <el-select
            class="k-promo-edit-form__places"
            v-model="points"
            multiple
            placeholder="Выбрать место"
          >
            <el-option
              v-for="item in allPoints"
              :key="item._id"
              :label="item.title"
              :value="item._id"
            />
          </el-select>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row :gutter="20" class="k-promo-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini" :disabled="!allowToSave">Сохранить</el-button>
        <el-button round @click="handleCancel" size="mini">Отмена</el-button>
      </el-row>

      <el-divider></el-divider>
      <p>* необходимо заполнить все поля</p>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

/**
 * Component: k-promo-edit-form - Форма для редактирования информации об акции
 *
 * @version 1.0.0
 */

const toStr = param => param ? param : '';
const toBool = param => param ? param : true;

export default {
  name: 'k-promo-edit-form',

  props: {
    // Является ли форма видимой
    dialogFormVisible: {
      type: Boolean,
      required: true,
    },

    // Данные точки для отображения
    promo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      name: '',
      description: '',
      email: '',
      amount: 1000,
      foundationId: null,
      startDate: null,
      endDate: null,
      points: [],
    };
  },

  computed: {
    ...mapGetters({
      foundations: 'foundations/foundations',
      allPoints: 'points/points',
    }),
    allowToSave() {
      return this.name
        && this.description
        && this.email
        && this.foundationId
        && this.startDate
        && this.endDate
        && this.points.length;
    },
  },

  watch: {
    promo: {
      handler: function(newValue) {
        this.setPromoData();
      },
      deep: true,
    },
  },

  async created() {
    if (this.promo) {
      this.setPromoData();
    }
    await this.getFoundations({
      limit: 1000,
      offset: 0,
    });
    await this.getPoints();
  },

  methods: {
    setPromoData() {
      this.name = this.promo.name ? this.promo.name : '';
      this.description = this.promo.description ? this.promo.description : '';
      this.email = this.promo.email ? this.promo.email : '';
      this.foundationId = this.promo.foundation && this.promo.foundation._id ? this.promo.foundation._id : null;
      this.startDate = this.promo.startDate ? this.promo.startDate : null;
      this.endDate = this.promo.endDate ? this.promo.endDate : null;
      this.amount = this.promo.amount ? this.promo.amount : 0;
      this.points = this.promo.points ? this.promo.points : [];
      this.challengeId = this.promo.challenge && this.promo.challenge._id ? this.promo.challenge._id : null;
    },

    // Отмена редактирования токена
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение информации о токене на бекенде
    async handleSave() {
      const promo = {
        name: this.name,
        description: this.description,
        email: this.email,
        foundationId: this.foundationId,
        startDate: this.startDate,
        endDate: this.endDate,
        amount: this.amount,
        points: this.points,
        challengeId: this.challengeId,
      };

      if (this.promo._id) {
        promo._id = this.promo._id;
      }

      await this.setPromo(promo);
      this.$emit('cancel');
    },

    ...mapActions({
      getFoundations: 'foundations/getFoundations',
      getPoints: 'points/getPoints',
      setPromo: 'promos/setPromo',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-promo-edit-form {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__upload {
    margin: 20px auto;
    text-align: center;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    margin-bottom: $vp;
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }

  &__icon {
    width: $icon-size;
    height: $icon-size;
    margin: 10px auto;
    border-radius: $icon-size / 2;
    background-color: black;

    & svg {
      width: $icon-size;
      height: $icon-size;
    }
  }

  &__places {
    width: 100%;
  }
}
</style>
